export default () => ({
  phoneMask: {},
  currency: {},
  footerInfo: null
})
